<!--
   Created by qing on 2020/2/19 2:25 下午
   Des:
-->
<template>
  <div v-if="filterWay">
    <SelectValue
      :disabled="disabled"
      :fields="fields"
      :isMultiple="isMultiple"
      :filterValue="current"
      :filter="filter"
      :formId="formId"
      @change="filterChange">
    </SelectValue>
  </div>

  <div v-else>
    <div v-if="isMultiple">
      <van-checkbox-group
        :disabled="disabled"
        @change="filterChange"
        v-model="singleChooseValue">
        <van-checkbox
          :disabled="disabled"
          v-for="(opt, idx) in field.options"
          icon-size="16"
          shape="square"
          :key="opt.id"
          :name="opt.id">
          <span>
            {{ opt.optionName }}
          </span>
        </van-checkbox>
      </van-checkbox-group>
    </div>

    <div v-else>

      <van-radio-group
        @change="filterChange"
        v-model="current[0]">
        <van-radio
          :disabled="disabled"
          v-for="(opt, idx) in field.options"
          icon-size="16"
          :key="opt.id"
          :name="opt.id">
          <span>
            {{ opt.optionName }}
          </span>
        </van-radio>
      </van-radio-group>
    </div>
  </div>
</template>

<script>
  import current from "./mixin"
  export default {
    mixins: [current],
    data() {
      return {};
    },
    computed: {
      singleChooseValue: {
        set(val) {
          this.current.splice(0, this.current.length, ...val)
        },
        get() {
          return this.current
        }
      }
    }
  };
</script>

<style lang="less" rel="stylesheet/less" scoped>

</style>
